import { render, staticRenderFns } from "./MnemonicWord.vue?vue&type=template&id=0f36839e&scoped=true&"
import script from "./MnemonicWord.vue?vue&type=script&lang=js&"
export * from "./MnemonicWord.vue?vue&type=script&lang=js&"
import style0 from "./MnemonicWord.vue?vue&type=style&index=0&id=0f36839e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f36839e",
  null
  
)

export default component.exports